module.exports = __webpack_public_path__ + "img/point_list.ea1e36bb.svg";